export enum SortDir {
  ASC = "asc",
  DESC = "desc",
}

export type CategoryRow = {
  name: string;
  nrTenants: number;
  general: number;
  recycled: number;
  recyclingRate: number;
};

export type KeyNumberColumn = {
  key: string;
  label: string;
  align: "left" | "right";
  getFormattedValue: (row: CategoryRow) => number | string;
  cellClassName: string;
  unit?: string;
};
